import { render, staticRenderFns } from "./promotion-experience.vue?vue&type=template&id=6006e4de&scoped=true"
import script from "./promotion-experience.vue?vue&type=script&lang=js"
export * from "./promotion-experience.vue?vue&type=script&lang=js"
import style0 from "./promotion-experience.vue?vue&type=style&index=0&id=6006e4de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6006e4de",
  null
  
)

export default component.exports